/* ============================================================
   Parts Schematic — JavaScript
   Upload to: Shopify Admin → Themes → Edit code → Assets

   Expects the section Liquid to set these before this script runs:
     window.__schemData        = {{ collection.metafields.custom.schem_json }};
     window.__schemProducts    = {{ collection.products | json }};
     window.__schemKey         = "{{ collection.metafields.custom.schematic_keys.value | downcase }}";
   ============================================================ */

(function () {
  'use strict';

  // ── Helpers ────────────────────────────────────────────────────────────────

  function findProductBySku(products, sku) {
    return products.find(function (prod) {
      return prod.variants.some(function (v) { return v.sku === sku; });
    });
  }

  /**
   * Walk up the DOM from `el` looking for an element whose id starts with
   * "legend-". Works correctly inside SVG where closest() can be unreliable
   * in older browsers and doesn't pierce shadow roots.
   */
  function closestLegend(el) {
    while (el && el !== document.body) {
      if (el.id && el.id.startsWith('legend-')) return el;
      el = el.parentElement;
    }
    return null;
  }

// Build a handle → product lookup from the Liquid-injected product array
var __productMap = {};
(window.__schemProducts || []).forEach(function(p) {
  __productMap[p.handle] = p;
});

function addToCart(variantId, btn) {
  btn.disabled = true;
  btn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(res) {
    if (!res.ok) throw new Error('Cart add failed');
    return res.json();
  })
.then(function() {
  btn.textContent = '✓ Added';
  btn.classList.add('atc-success');

  // Let the theme's own refresh handler update the drawer
  document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));

  // Update header count separately
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var countEl = document.querySelector('.header__cart-count-number');
      var countElHidden = document.querySelector('.header__cart-count .visually-hidden');
      if (countEl) countEl.textContent = cart.item_count;
      if (countElHidden) countElHidden.textContent = cart.item_count + ' items';
    });

  setTimeout(function() {
    btn.textContent = 'Add to Cart';
    btn.classList.remove('atc-success');
    btn.disabled = false;
  }, 2000);
})
  .catch(function() {
    btn.textContent = 'Error — Retry';
    btn.classList.add('atc-error');
    btn.disabled = false;
    setTimeout(function() {
      btn.textContent = 'Add to Cart';
      btn.classList.remove('atc-error');
    }, 2500);
  });
}


  // ── Drawer ─────────────────────────────────────────────────────────────────

function openDrawer(partsArray, legendValue) {
  var drawerContent = document.getElementById('drawer-content');
  if (!drawerContent) return;
  drawerContent.innerHTML = '';

  // Header
  var header = document.createElement('h4');
  header.className = 'drawer-header';
  if (legendValue) {
    header.innerHTML = 'Legend #' + legendValue;
    if (partsArray.length > 0 && partsArray[0].short) {
      header.innerHTML += " - <span class='legend-short'>" + partsArray[0].short + '</span>';
    }
  } else {
    header.textContent = 'Click on a part to view details';
  }
  drawerContent.appendChild(header);

  // Part items
  partsArray.forEach(function(data) {
var variantId = data.variant_id || null;
var available = data.available || false;

    // Image
    var imgSrc = data.featured_image
      ? data.featured_image.replace('.webp', '_small.webp')
      : null;
    if (imgSrc && imgSrc.startsWith('//')) imgSrc = 'https:' + imgSrc;

    // Price
// Price
    var priceDisplay = data.price && !data.price.includes('Not') ? data.price : '';

    var item = document.createElement('div');
    item.className = 'part-item';

    item.innerHTML =
      '<div class="part-item-inner">' +
        (imgSrc
          ? '<div class="part-item-img-wrap"><a href="/products/' + data.handle + '" target="_blank"><img src="' + imgSrc + '" alt="' + data.title + '"></a></div>'
          : '') +
        '<div class="part-item-details">' +
          '<h6 class="part-item-title">' +
            (data.handle
              ? '<a href="/products/' + data.handle + '" target="_blank">' + data.title + '</a>'
              : data.title) +
          '</h6>' +
          '<p class="part-item-sku"><span>SKU</span> ' + data.sku + '</p>' +
          (priceDisplay ? '<p class="part-item-price">' + priceDisplay + ' <span class="part-item-per-ea">/ea</span></p>' : '') +
          (data.description ? '<p class="part-item-desc">' + data.description + '</p>' : '') +
        '</div>' +
      '</div>' +
      '<div class="part-item-footer">' +
        (available && variantId
          ? '<button class="part-atc-btn" data-variant-id="' + variantId + '">Add to Cart</button>'
          : '<span class="part-unavailable">Unavailable</span>') +
        (data.handle
          ? '<a class="part-details-link" href="/products/' + data.handle + '" target="_blank">View Details →</a>'
          : '') +
      '</div>';

    drawerContent.appendChild(item);
  });

  // ATC button listeners
  drawerContent.querySelectorAll('.part-atc-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      addToCart(parseInt(btn.dataset.variantId), btn);
    });
  });

  var drawer = document.getElementById('parts-drawer');
  drawer.classList.add('open');
  drawer.scrollIntoView({ behavior: 'smooth' });
}

  function closeDrawer() {
    var drawer = document.getElementById('parts-drawer');
    if (drawer) drawer.classList.remove('open');
    clearSelectedLegends();
  }

  // ── Legend highlight helpers ────────────────────────────────────────────────

  function clearSelectedLegends() {
    document.querySelectorAll('[id^="legend-"]').forEach(function (el) {
      el.classList.remove('selected-legend');
    });
  }

  function selectLegend(legend) {
    var re = new RegExp('^legend-' + legend + '(_)?$');
    document.querySelectorAll('[id^="legend-"]').forEach(function (el) {
      if (re.test(el.id)) {
        el.classList.add('selected-legend');
      } else {
        el.classList.remove('selected-legend');
      }
    });
  }

  // ── Pan-zoom setup ──────────────────────────────────────────────────────────

  function initPanZoom(svgElement, container) {
    var isTouch = window.matchMedia('(pointer: coarse)').matches;

    // Hint bar — desktop only
    if (!isTouch) {
      var hintBar = document.createElement('div');
      hintBar.className = 'zoom-hint-bar';
      hintBar.innerHTML = '<kbd>Ctrl</kbd> + scroll to zoom &nbsp;&middot;&nbsp; drag to pan';
      container.parentNode.insertBefore(hintBar, container);
    }

    var spzScript = document.createElement('script');
    spzScript.src = 'https://cdn.jsdelivr.net/npm/svg-pan-zoom@3.6.1/dist/svg-pan-zoom.min.js';

    spzScript.onload = function () {
      svgElement.setAttribute('width',  container.offsetWidth  || 800);
      svgElement.setAttribute('height', container.offsetHeight || 520);

      var panZoom = svgPanZoom(svgElement, {
        zoomEnabled:               true,
        dblClickZoomEnabled:       false,
        panEnabled:                true,
        controlIconsEnabled:       false,
        fit:                       true,
        center:                    true,
        minZoom:                   0.9,
        maxZoom:                   7,
        zoomScaleSensitivity:      0.25,
        preventMouseEventsDefault: false,
beforePan: function(oldPan, newPan) {
  if (!mouseInContainer) return oldPan;

  var sizes   = panZoom.getSizes();
  var zoom    = panZoom.getZoom();
  var padding = 200;

  var overflowX = Math.max(0, sizes.viewBox.width  * zoom * sizes.realZoom - sizes.width);
  var overflowY = Math.max(0, sizes.viewBox.height * zoom * sizes.realZoom - sizes.height);

  var maxX = overflowX / 2 + padding;
  var maxY = overflowY / 2 + padding;

  return {
    x: Math.max(-maxX, Math.min(maxX, newPan.x)),
    y: Math.max(-maxY, Math.min(maxY, newPan.y))
  };
},
      });

      // Touch: single-finger pan via manual tracking
if (isTouch) {
  panZoom.disablePan();

  var lastTouchX = 0, lastTouchY = 0;
  var lastDist = null;
  var isPinching = false;  // 👈 add this

  function getPinchDist(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function getPinchMidpoint(touches) {
    var rect = container.getBoundingClientRect();
    return {
      x: ((touches[0].clientX + touches[1].clientX) / 2) - rect.left,
      y: ((touches[0].clientY + touches[1].clientY) / 2) - rect.top
    };
  }

  container.addEventListener('touchstart', function(e) {
    if (e.touches.length === 1) {
      isPinching = false;
      lastTouchX = e.touches[0].clientX;
      lastTouchY = e.touches[0].clientY;
      lastDist = null;
    }
    if (e.touches.length === 2) {
      e.preventDefault();
      isPinching = true;  // 👈 block pan
      lastDist = getPinchDist(e.touches);
    }
  }, { passive: false });


  container.addEventListener('touchmove', function(e) {
    if (e.touches.length === 1 && !isPinching) {
      // Single finger pan — only when not pinching
      e.preventDefault();
      var dx = e.touches[0].clientX - lastTouchX;
      var dy = e.touches[0].clientY - lastTouchY;
      lastTouchX = e.touches[0].clientX;
      lastTouchY = e.touches[0].clientY;

      var sizes = panZoom.getSizes();
      var pan   = panZoom.getPan();
      var zoom  = panZoom.getZoom();
var overflowX = Math.max(0, sizes.viewBox.width  * zoom * sizes.realZoom - sizes.width);
var overflowY = Math.max(0, sizes.viewBox.height * zoom * sizes.realZoom - sizes.height);
var maxX = overflowX / 2 + 200;
var maxY = overflowY / 2 + 200;

      panZoom.pan({
        x: Math.max(-maxX, Math.min(maxX, pan.x + dx)),
        y: Math.max(-maxY, Math.min(maxY, pan.y + dy))
      });

    } else if (e.touches.length === 2) {
      e.preventDefault();
      var newDist = getPinchDist(e.touches);
      if (lastDist) {
        var rawScale = newDist / lastDist;
        var scaleFactor = rawScale;
        if (Math.abs(rawScale - 1) > 0.005) {
          var centerPoint = {
            x: container.offsetWidth / 2,
            y: container.offsetHeight / 2
          };
          panZoom.zoomAtPoint(panZoom.getZoom() * scaleFactor, centerPoint);
        }
      }
      lastDist = newDist;
    }
  }, { passive: false });

  container.addEventListener('touchend', function(e) {
    if (e.touches.length < 2) {
      if (lastDist !== null) {
        var pan = panZoom.getPan();
        panZoom.pan({ x: pan.x, y: pan.y });
      }
      lastDist = null;
    }
    // Only clear isPinching when ALL fingers are lifted
    if (e.touches.length === 0) {
      isPinching = false;
      lastTouchX = 0;
      lastTouchY = 0;
    }
  }, { passive: true });
}

      // Reveal once initialised
      container.classList.add('spz-ready');

var mouseInContainer = true;
container.addEventListener('mouseenter', function() { mouseInContainer = true; });
container.addEventListener('mouseleave', function() { mouseInContainer = false; });

container.addEventListener('mousedown', function() {
  container.style.cursor = 'grabbing';
  document.body.style.userSelect = 'none';
});

document.addEventListener('mouseup', function() {
  container.style.cursor = 'grab';
  document.body.style.userSelect = '';
});

      // Zoom / reset buttons
      var controls = document.createElement('div');
      controls.className = 'spz-controls';
      controls.innerHTML =
        '<button id="spz-in"    aria-label="Zoom in">+</button>' +
        '<button id="spz-reset" aria-label="Reset view" style="font-size:13px;">Reset</button>' +
        '<button id="spz-out"   aria-label="Zoom out">−</button>';
      container.appendChild(controls);

      document.getElementById('spz-in').addEventListener('click', function (e) {
        e.stopPropagation(); panZoom.zoomIn();
      });
      document.getElementById('spz-out').addEventListener('click', function (e) {
        e.stopPropagation(); panZoom.zoomOut();
      });
document.getElementById('spz-reset').addEventListener('click', function (e) {
  e.stopPropagation();
  setTimeout(function() {
    panZoom.fit();
    panZoom.center();
  }, 50);
});

      // Desktop: Ctrl+scroll only
      if (!isTouch) {
        panZoom.disableZoom();
        container.addEventListener('wheel', function (e) {
          if (e.ctrlKey || e.metaKey) {
            e.preventDefault();
            e.stopPropagation();
            var factor = e.deltaY < 0 ? 1.25 : 0.8;
            var rect   = container.getBoundingClientRect();
            panZoom.zoomAtPoint(
              panZoom.getZoom() * factor,
              { x: e.clientX - rect.left, y: e.clientY - rect.top }
            );
          }
        }, { passive: false });
      }

      // Re-fit on resize
      window.addEventListener('resize', function () {
        svgElement.setAttribute('width',  container.offsetWidth  || 800);
        svgElement.setAttribute('height', container.offsetHeight || 520);
        panZoom.resize();
        panZoom.fit();
        panZoom.center();
      });
    };

    document.head.appendChild(spzScript);
  }

function fetchAllProducts(handle, callback) {
  var products = [];
  var page = 1;

  function fetchPage() {
    fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var batch = data.products;
        products = products.concat(batch);
        if (batch.length === 250) {
          page++;
          fetchPage();
        } else {
          callback(products);
        }
      });
  }

  fetchPage();
}

  // ── Main init ───────────────────────────────────────────────────────────────

  function init() {
    var schemData = window.__schemData;
    var products  = window.__schemProducts;
    var schemKey  = window.__schemKey;

    if (!schemData || !products || !schemKey) {
      console.error('Parts Schematic: missing window.__schemData / __schemProducts / __schemKey');
      return;
    }

    // Build legend → parts map (strip trailing underscores from legend keys)
    var partsByLegend = {};
    schemData.forEach(function (part) {
      var key = part.legend.replace(/_+$/, '');
      if (!partsByLegend[key]) partsByLegend[key] = [];
      partsByLegend[key].push(part);
    });

    // Find the SVG
    var svgId = schemKey + 'schem';
    var svgElement = document.getElementById(svgId);
    if (!svgElement) {
      console.error("Parts Schematic: SVG element '#" + svgId + "' not found.");
      return;
    }

    var container = svgElement.closest('.schematic-container');

    // Pan-zoom
    initPanZoom(svgElement, container);

    // Legend click handlers
    Object.keys(partsByLegend).forEach(function (legend) {
      var elementId = 'legend-' + legend;
      var element   = svgElement.getElementById(elementId) || svgElement.getElementById(elementId + '_');
      if (!element) {
        console.warn("Parts Schematic: SVG element '" + elementId + "' not found. Skipping.");
        return;
      }

        var hasMatch = partsByLegend[legend].some(function (part) {
    return !!findProductBySku(products, part.sku);
  });

    if (!hasMatch) {
    element.classList.add('no-stock-legend');
  }

      element.addEventListener('click', function (e) {
        e.stopPropagation();
        selectLegend(legend);

        var displayData = [];
        partsByLegend[legend].forEach(function (part) {
          var product = findProductBySku(products, part.sku);
          if (product) {
            var variant = product.variants[0];
            displayData.push({
              title:          product.title,
              sku:            part.sku,
              price:          '$' + parseFloat(variant.price).toFixed(2),
              description:    part.shortDescription || part.description,
              featured_image: product.images && product.images[0] ? product.images[0].src : null,
              handle:         product.handle,
              available:      variant.available,
              product_id:     product.id,
              variant_id:     variant.id,
              short:          part.short || ''
            });
          } else {
            displayData.push({
              title:       part.sku,
              sku:         part.sku,
              price:       'Not currently listed on website',
              description: part.shortDescription || part.description,
              handle:      '',
              short:       part.short || ''
            });
          }
        });

        // Available products first
        displayData.sort(function (a, b) {
          return (b.available ? 1 : 0) - (a.available ? 1 : 0);
        });

        openDrawer(displayData, legend);
      });
    });

    // Close drawer — button
    var closeBtn = document.getElementById('drawer-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    // Close drawer — click outside (SVG-safe: walk up via closestLegend)
    document.addEventListener('click', function (e) {
      var drawer = document.getElementById('parts-drawer');
      if (!drawer) return;

      var insideDrawer = drawer.contains(e.target);
      var insideLegend = !!closestLegend(e.target);

      if (!insideDrawer && !insideLegend) {
        closeDrawer();
      }
    });
  }

// Run after DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      fetchAllProducts(window.__schemCollectionHandle, function(products) {
        window.__schemProducts = products;
        products.forEach(function(p) { __productMap[p.handle] = p; });
        init();
        document.dispatchEvent(new CustomEvent('schemProductsReady'));
      });
    });
  } else {
    fetchAllProducts(window.__schemCollectionHandle, function(products) {
      window.__schemProducts = products;
      products.forEach(function(p) { __productMap[p.handle] = p; });
      init();
      document.dispatchEvent(new CustomEvent('schemProductsReady'));
    });
  }

})();